import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2, ShieldCheck, Rocket } from 'lucide-react';
export const MetodoRaices = () => {
  const includes = ['Auditoría de stock dormido — mapa de qué mover primero y qué no tocar todavía', 'Fórmula del precio de salida — calculás el descuento máximo sin perder margen', 'Los 4 tipos de promo que mueven stock sin quemar precio', 'Secuencia completa de 4 estados de WhatsApp para vender en 24 horas', 'Secuencia de stories de Instagram para campañas express', 'Scripts de reactivación para clientas que compraron, consultaron o reservaron y desaparecieron', 'Mensajes de difusión listos para copiar y adaptar', 'Plan completo de campaña viernes-sábado-domingo paso a paso', 'Checklist previo a campaña para no lanzar a medias', 'Tracker de resultados para medir qué funcionó y repetirlo', 'Protocolo de corrección si nadie respondió', 'Estrategias especiales para talles sueltos, colores difíciles y prendas únicas', 'Caso real completo: de $42.000 en stock dormido a $81.500 en 48 horas'];
  const comparisons = [{
    situacion: 'Tenés mercadería parada hace meses',
    sin: 'Sabés que está pero no sabés qué hacer',
    con: 'Campaña de 48 horas para convertirla en caja'
  }, {
    situacion: 'Tenés clientas que compraron y nunca más volvieron',
    sin: 'Esperás que vuelvan solas',
    con: 'Scripts de reactivación que las traen de vuelta'
  }, {
    situacion: 'Subís cosas al estado de WhatsApp y nadie responde',
    sin: 'Seguís probando sin sistema',
    con: 'Secuencia de 4 estados con timing exacto que genera ventas en 24 horas'
  }, {
    situacion: 'Querés mover stock sin regalar margen',
    sin: 'Bajás el precio a ojo y perdés ganancia',
    con: 'Fórmula de precio de salida que protege tu margen siempre'
  }, {
    situacion: 'Necesitás caja rápida esta semana',
    sin: 'No sabés por dónde empezar',
    con: 'Plan viernes-sábado-domingo con cada paso detallado'
  }, {
    situacion: 'Tenés $40.000 en mercadería dormida',
    sin: 'Ese dinero sigue sin moverse',
    con: 'Primera campaña que lo convierte en ventas reales'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-178">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-179"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-180">
        <FadeIn data-id="element-181">
          <div className="text-center mb-16" data-id="element-182">
            <div className="inline-flex items-center justify-center bg-pink-500/10 px-4 py-2 rounded-full border border-pink-500/20 mb-6" data-id="element-183">
              <Rocket className="w-5 h-5 text-pink-400 mr-2" data-id="element-184" />
              <span className="text-pink-400 font-bold tracking-[0.2em] text-[10px] md:text-xs uppercase font-sans" data-id="element-185">
                CONTENIDO EXCLUSIVO
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl text-white mb-6 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-186">
              🚀 ¿Qué agrega el Kit Venta Relámpago?
            </h2>
            <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-base md:text-lg font-sans font-medium" data-id="element-187">
              Para las que quieren pasar de ordenar el negocio a hacer que el
              negocio produzca más.
            </p>
            <div className="mt-8 text-left max-w-3xl mx-auto text-gray-300 space-y-4 font-sans" data-id="element-188">
              <p data-id="element-189">
                El Método Caja Ordenada ordena tu negocio y te muestra cuánto
                stock dormido tenés, cuántas clientas no volvieron y cuánta
                plata estás dejando ir por desorden.
              </p>
              <p className="text-white font-bold" data-id="element-190">
                El Kit Venta Relámpago te dice qué hacer con todo eso.
              </p>
              <p data-id="element-191">
                Campañas de 48 horas para convertir stock parado en caja.
                Scripts para reactivar clientas que compraron una vez y
                desaparecieron. Secuencias de estados de WhatsApp que generan
                ventas sin publicidad. Urgencia real sin parecer desesperada.
              </p>
            </div>
          </div>

          <div className="space-y-6 mb-16" data-id="element-192">
            {/* Desktop Header */}
            <div className="hidden md:grid grid-cols-3 gap-6 px-8 py-4 bg-navy-950/60 rounded-2xl border border-white/5 mb-2 font-sans" data-id="element-193">
              <div className="text-gray-400 font-bold text-xs uppercase tracking-widest" data-id="element-194">
                Situación
              </div>
              <div className="text-red-400/80 font-bold text-xs uppercase tracking-widest" data-id="element-195">
                ❌ Sin Kit Venta Relámpago
              </div>
              <div className="text-green-400 font-bold text-xs uppercase tracking-widest" data-id="element-196">
                ✅ Con Kit Venta Relámpago
              </div>
            </div>

            <div className="grid gap-4 md:gap-5" data-id="element-197">
              {comparisons.map((item, idx) => <div key={idx} className="bg-navy-950/40 rounded-2xl border border-white/5 p-5 md:p-6 overflow-hidden hover:border-white/10 transition-colors" data-id="element-198">
                  <div className="md:grid md:grid-cols-3 md:gap-6 items-start" data-id="element-199">
                    <div className="mb-5 md:mb-0" data-id="element-200">
                      <span className="text-[9px] uppercase tracking-[0.2em] text-gray-400 font-bold md:hidden block mb-2 font-sans" data-id="element-201">
                        Situación
                      </span>
                      <p className="text-white font-bold text-sm md:text-base leading-snug font-sans" data-id="element-202">
                        {item.situacion}
                      </p>
                    </div>

                    <div className="flex flex-col gap-4 md:contents" data-id="element-203">
                      <div className="md:pr-4" data-id="element-204">
                        <span className="text-[9px] uppercase tracking-[0.2em] text-red-400/80 font-bold md:hidden flex items-center gap-1.5 mb-2 font-sans" data-id="element-205">
                          ❌ Sin Kit Venta Relámpago
                        </span>
                        <p className="text-gray-300 text-xs md:text-sm leading-relaxed font-sans" data-id="element-206">
                          {item.sin}
                        </p>
                      </div>

                      <div className="bg-green-500/5 md:bg-transparent p-4 md:p-0 rounded-xl border border-green-500/10 md:border-none relative" data-id="element-207">
                        <span className="text-[9px] uppercase tracking-[0.2em] text-green-400 font-bold md:hidden flex items-center gap-1.5 mb-2 font-sans" data-id="element-208">
                          ✅ Con Kit Venta Relámpago
                        </span>
                        <p className="text-green-400 font-bold text-sm md:text-base leading-snug font-sans" data-id="element-209">
                          {item.con}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="bg-gradient-to-b from-navy-900 to-navy-950 border border-white/5 rounded-3xl p-6 md:p-12 relative overflow-hidden" data-id="element-210">
            <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-pink-500/30 to-transparent" data-id="element-211" />
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-pink-500/5 blur-3xl rounded-full" data-id="element-212"></div>

            <h3 className="text-xl md:text-3xl text-center text-white mb-8 md:mb-10 font-[900] font-[Montserrat,_sans-serif]" data-id="element-213">
              ✅ KIT VENTA RELÁMPAGO INCLUYE:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-214">
              {includes.map((item, index) => <div key={index} className="flex items-start space-x-4 bg-navy-950/50 border border-white/5 p-5 rounded-xl hover:bg-navy-900/50 transition-colors" data-id="element-215">
                  <CheckCircle2 className="w-5 h-5 text-pink-400 flex-shrink-0 mt-0.5 opacity-90" data-id="element-216" />
                  <span className="text-gray-100 font-medium text-sm md:text-base leading-relaxed font-sans" data-id="element-217">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};